import type { ReactNode } from 'react';

/** Colour of the verb that opens the text of a change: what the change does, readable at a glance. */
const COLOR_DE_ACCION: Record<string, string> = {
	Agregar: 'text-emerald-700',
	Quitar: 'text-red-600',
	Cambiar: 'text-sky-700',
	Conservar: 'text-amber-700',
};

const ACCION_INICIAL = /^(Agregar|Quitar|Cambiar|Conservar)\b/;

/**
 * The text of one adscription change ("Agregar …", "Quitar …", "Cambiar la unidad principal a …") with its opening
 * verb in colour and every «quoted» unit name in bold without the guillemets. Text that opens with no known verb
 * is shown as is (names still in bold). `verboEnColor={false}` leaves the verb in bold only, for lists where an icon already
 * carries the colour.
 */
export function TextoDeCambio({ texto, verboEnColor = true }: { texto: string; verboEnColor?: boolean }) {
	const accion = ACCION_INICIAL.exec(texto)?.[1];
	if (!accion) return <>{conNombresEnNegrita(texto)}</>;
	return (
		<>
			<span className={`font-semibold ${verboEnColor ? COLOR_DE_ACCION[accion] : 'text-slate-900'}`}>{accion}</span>
			{conNombresEnNegrita(texto.slice(accion.length))}
		</>
	);
}

function conNombresEnNegrita(texto: string): ReactNode[] {
	return texto.split(/«([^»]*)»/).map((parte, indice) =>
		indice % 2 === 1 ? (
			<strong key={indice} className="font-semibold text-slate-900">
				{parte}
			</strong>
		) : (
			parte
		),
	);
}
